import { DeviceMicState } from '@shure/shared/angular/data-access/system-api/models';

import { MicStatus, MicStatusV2 } from '../graphql/generated/cloud-sys-api';

export function mapMicStatusFromSysApi(micStatus: MicStatus | MicStatusV2 | undefined | null): DeviceMicState {
	switch (micStatus) {
		case MicStatus.Active:
		case MicStatusV2.Active:
			return DeviceMicState.Active;

		case MicStatus.Mute:
		case MicStatusV2.Mute:
			return DeviceMicState.Mute;

		case MicStatus.Off:
			return DeviceMicState.Off;

		case MicStatus.Standby:
			return DeviceMicState.Standby;

		case MicStatus.OnCharger:
		case MicStatusV2.OnCharger:
			return DeviceMicState.OnCharger;

		case MicStatus.OutOfRange:
			return DeviceMicState.OutOfRange;

		case MicStatus.Unknown:
		default:
			return DeviceMicState.Unknown;
	}
}
